import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { RadioGroup } from "@website/ui/radio-group";
import { deepCompare } from "@website/utils/deep-compare";
import { ReserveCommentFilterItemTypes } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter-item/reserve-comment-filter-item.types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = ({
  startIconName,
  filterName,
  radioItems,
  onLoadFilter,
  isInsideDetail
}: ReserveCommentFilterItemTypes) => {
  const router = useRouter();
  return (
    <div className="relative">
      <Button
        variant="text"
        color="neutral"
        StartIcon={<MaterialIcon name={startIconName} />}
        text={filterName?.fa}
        onClick={() =>
          router.push(
            {
              pathname: router.pathname,
              query: {
                ...router?.query,
                popover: "sort"
              }
            },
            undefined,
            { shallow: true, scroll: false }
          )
        }
      />
      <MiniPopover
        animate="bottom"
        className="left-0"
        defaultHorizontalPosition="end"
        onClose={() =>
          router.push(
            {
              pathname: router.pathname,
              query: omit(router?.query, "popover")
            },
            undefined,
            { shallow: true, scroll: false }
          )
        }
        open={router.query?.["popover"] === "sort"}
        title="مرتب‌سازی"
      >
        <RadioGroup
          className="text-subtitle-2 flex-col px-6 py-4"
          color="secondary"
          items={radioItems}
          name={filterName?.fa}
          onChange={(event) => {
            router.push(
              {
                pathname: router.pathname,
                query: {
                  ...omit(router?.query, "popover"),
                  order_by: event.target?.value
                }
              },
              undefined,
              { shallow: true, scroll: false }
            );
            return onLoadFilter
              ? onLoadFilter(
                  { order_by: String(event.target?.value) },
                  isInsideDetail
                )
              : null;
          }}
          value={router?.query?.["order_by"]}
        />
      </MiniPopover>
    </div>
  );
};
export const ReserveCommentsSort = memo(Component, deepCompare);
